<template>
  <card :has-settings="false" :has-subtitle="false" auto-height title="Patient Attributes" :class="{'overflow-visible': editMode}">
    <template #headerUtils v-if="$can('Edit', 'PatientMonitor') && patient">
      <button class="button is-outlined is-primary" :class="{'is-focused': editMode}" @click="editMode = true">Edit</button>
    </template>
    <template #content>
      <div v-if="editMode">
        <input-with-validation expanded>
          <template #custom>
            <ld-taginput v-model="selectedAttributes" :data="attributes" :input-props="{ field: 'name', placeholder: 'Click to select', type: 'is-primary' }" @update:modelValue="$emit('attribute-changed', $event.map(x => x.id))">
              <template #not-found>
                <p>No attribute found</p>
              </template>
              <template #all-selected>
                <p>All attributes are selected</p>
              </template>
            </ld-taginput>
          </template>
        </input-with-validation>
        <div class="is-flex is-justify-content-center">
          <button class="button is-white" @click="cancel">Cancel</button>
          <button class="button is-primary" @click="save">Save</button>
        </div>
      </div>
      <div v-else>
        <template v-if="patientTags.length">
          <div class="attributes">
            <div class="tag is-primary" :key="index" v-for="(attribute, index) in patientTags">
              {{ attribute.name }}
            </div>
          </div>
        </template>
        <div v-else class="no-data-message">
          <p>Patient monitor doesn't have any attributes</p>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import to from "@/lib/to";
import Card from "@/components/card/Card";
import LdTaginput from "@/components/LdTaginput";
import InputWithValidation from "@/components/validation/InputWithValidation";
import {EventBus, EVENTS} from "@/lib/EventBus";

export default {
  name: "PatientTags",
  components: {InputWithValidation, LdTaginput, Card},
  props: {
    patient: {
      type: Object
    },
    monitorId: {
      type: Number,
      required: false,
      default: null
    }
  },
  watch: {
    patient: {
      handler(newVal) {
        if (newVal) {
          this.patientTags = newVal.patient_tags.map(x => x.tag)
        }
      },
      immediate: true
    },
    async editMode(newVal) {
      if (newVal) {
        const [err, response] = await to(this.$http.get('/tags/dropdown'))
        if (!err) {
          this.attributes = response.data
          this.selectedAttributes = [...this.patientTags]
        }
      }
    }
  },
  methods: {
    cancel() {
      this.editMode = false
    },
    async save() {
      const [err, ] = await to(this.$http.post(`/patients/${this.patient.id}/save_tags`, { tags: this.selectedAttributes.map(x => x.id) }))
      if (!err) {
        this.editMode = false
        this.patientTags = [...this.selectedAttributes]
        if (this.monitorId) {
          EventBus.$emit(EVENTS.RELOAD_WIDGET_MONITOR_DATA, this.monitorId)
        }
        this.$buefy.toast.open({
          message: 'Attributes saved successfully',
          type: 'is-success'
        });
      }
    }
  },
  data() {
    return {
      editMode: false,
      patientTags: [],
      attributes: [],
      selectedAttributes: []
    }
  }

}
</script>

<style scoped lang="scss">
.attributes {
  display: flex;
  flex-wrap: wrap;
  > div {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
.overflow-visible :deep(.monitoring-card__content) {
  overflow: visible;
}
</style>
